<template>
  <validation-observer ref="create-offer">
    <b-form class="p-2" @submit.prevent>
      <b-row>
        <b-col cols="12">
          <div class="py-2 font-weight-bold text-uppercase">
            Condiciones económicas
          </div>
        </b-col>
        <b-col sm="12" md="6">
          <b-row>
            <b-col sm="12">
              <validation-provider
                v-slot="validationContext"
                name="Forma de pago"
                rules="required"
              >
                <b-form-group
                  label="Forma de pago"
                  label-for="client-type-payment"
                >
                  <BaseSelect
                    id="client-type-payment"
                    :value="model.type_payment"
                    :resource="
                      $data.$constants.RESOURCES.RESOURCE_TYPE_PAYMENTS
                    "
                    @input="update('type_payment', $event)"
                    :error="validationContext.errors[0]"
                  />
                  <small class="text-danger">{{
                    validationContext.errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col sm="12">
              <validation-provider
                v-slot="validationContext"
                name="Hitos de facturación"
                rules="required"
              >
                <b-form-group label="Hitos de facturación" label-for="hitos">
                  <b-form-input
                    id="hitos"
                    :value="model.billing_milestone"
                    placeholder="Hitos de facturación"
                    @input="update('billing_milestone', $event)"
                    :class="{'error': validationContext.errors[0]}"
                  />
                  <small class="text-danger">{{
                    validationContext.errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col sm="12">
              <validation-provider
                v-slot="validationContext"
                name="Avales y garantías"
                rules="required"
              >
                <b-form-group
                  label="Avales y garantías"
                  label-for="endorsements_and_guarantees"
                >
                  <b-form-input
                    id="endorsements_and_guarantees"
                    :value="model.endorsements_and_guarantees"
                    placeholder="Avales y garantías"
                    @input="update('endorsements_and_guarantees', $event)"
                    :class="{'error': validationContext.errors[0]}"
                  />
                  <small class="text-danger">{{
                    validationContext.errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col sm="12">
              <validation-provider
                v-slot="validationContext"
                name="Tipo de impuesto"
                rules="required"
              >
                <b-form-group label="Tipo de impuesto" label-for="client-iva">
                  <TaxesSelect
                    :value="model.tax"
                    @input="update('tax', $event)"
                    :error="validationContext.errors[0]"
                  />
                  <small class="text-danger">{{
                    validationContext.errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" md="6">
          <b-row>
            <b-col sm="12">
              <validation-provider
                v-slot="validationContext"
                name="Condiciones de retenciones"
                rules="required"
              >
                <b-form-group
                  label="Condiciones de retenciones"
                  label-for="withholding_conditions"
                >
                  <b-form-input
                    id="withholding_conditions"
                    :value="model.withholding_conditions"
                    placeholder="Condiciones de retenciones"
                    @input="update('withholding_conditions', $event)"
                    :class="{'error': validationContext.errors[0]}"
                  />
                  <small class="text-danger">{{
                    validationContext.errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col sm="12">
              <b-form-group label="Adjuntar Archivos">
                <FileDropZone
                  ref="documentation-input"
                  :files="files"
                  @removed-file="removedFiles.push($event)"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import FormMixin from "@/mixins/formMixin";
import FileDropZone from "@/components/ui/file/FileDropZone.vue";
import BaseSelect from "@/components/ui/select/BaseSelect.vue";
import TaxesSelect from "@/components/tax/select/TaxesSelect.vue";

export default {
  components: {
    FileDropZone,
    BaseSelect,
    TaxesSelect,
  },
  mixins: [FormMixin],
  data() {
    return {
      removedFiles: [],
    };
  },
  computed: {
    files() {
      return this.value?.documentation || [];
    },
  },
  methods: {
    validateForm() {
      return this.$refs["create-offer"].validate();
    },
    getDocumentationData() {
      return {
        documentation: this.$refs["documentation-input"].getFiles(),
        removedFiles: this.removedFiles,
      };
    },
  },
};
</script>

<style>
.error {
  border: 1px solid red !important;
  border-radius: 0.357rem
}

</style>